<template>
  <div class="card-personalizada">
    <div class="card-header text-left card-header-novedad">
      <b>Reportes del mes {{ get_mont_name(get_mont) }} - General</b>
    </div>
    <div class="card-body pl-4">
      <div class="row mt-3">
        <div class="col-12 mb-4">
          <b-form-datepicker locale="es" v-model="date" size="lg"
            :class="`mb-2 ${getErrors.date ? 'is-invalid' : null}`" :max="date_end" />
          <b-form-invalid-feedback>
            {{ getErrors.date }}

          </b-form-invalid-feedback>
        </div>

        <div class="col-12" v-if="date">
          <div class="row" v-for="(report, key_report) in list_report" :key="key_report">
            <div class="col-md-9 mt-2">
              <div class="title-row">{{ report.title }}</div><br>
              <!--<div class="subtitle-row">Julio de 2021 </div>-->
            </div>
            <div class="col-md-3 text-right mt-2">
              <b-button :disabled="processing" pill class="text-center" variant="outline-primary"
                @click="getReport(report.key)">
                <div v-if="processing && click_current === report.key">
                  Descargando
                  <b-spinner small />
                </div>
                <div v-else>
                  Descargar
                  <span class="icon icon-download" />
                </div>
              </b-button>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- modal -->
    <div>
      <b-modal :ref="modal_name" hide-footer centered title="Atención al mensaje:" no-close-on-backdrop
        @hidden="hideModal(modal_name)">
        <div class="d-block text-center">
          <h3>{{ message_of_modal }}</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideModal(modal_name)">
          Cerrar
        </b-button>
      </b-modal>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex"

// import XLSX from 'xlsx'
export default {
  name: "ReportGeneral",
  data: () => ({
    date: null,
    processing: false,
    click_current: 0,
    date_end: null,
    message_of_modal: ""
  }),
  props: ['row'],
  computed: {
    ...mapGetters("modSiesaReport", [
      "getErrors",
      "getExportList"
    ]),
    modal_name() {
      return "modal-report-general"
    },
    list_report() {
      return [
        {
          title: "Reporte mensual de empleados tercerizados",
          key: 1
        },
        {
          title: "Reporte mensual de empleados directos",
          key: 2
        },
        {
          title: "Reporte consolidado de propinas",
          key: 3
        }
      ]
    }
  },
  beforeMount() {
    this.date_end = this.get_today
  },
  methods: {
    ...mapActions("modSiesaReport", [
      "outSourcedExport",
      "directExport",
      "consolidatedTipsExport"
    ]),

    async getReport(val) {
      const values = {
        1: this.retrieveOutSourcedExport,
        2: this.retrieveDirectExport,
        3: this.retrieveConsolidatedTipsExport
      }
      if (values[val]) {
        this.processing = true
        this.click_current = val
        await values[val](this.date)
        return this.processing = false
      }
      this.message_of_modal = "¡Por favor!, valida la información"
      this.showModal(this.modal_name)
      // data of date in noviembre 2021-11-18
      /*switch(val){
        case 1:
          window.open('https://api-dev.virtualpartner.com.co/outsourcedexport/2021-12-01','_blank');
          break;
        case 2:
          window.open('https://api-dev.virtualpartner.com.co/directexport/2021-12-01','_blank');
          break;
        case 3:
          window.open('https://api-dev.virtualpartner.com.co/consolidatedtipsexport/2021-12-01','_blank');
          break;
      }*/
    },
    async retrieveOutSourcedExport(date = "") {
      await this.outSourcedExport(date)
      await this.downloadFile("Empleados tercerizados")
    },
    async retrieveDirectExport(date = "") {
      await this.directExport(date)
      await this.downloadFile("Empleados directos")
    },
    async retrieveConsolidatedTipsExport(date = "") {
      await this.consolidatedTipsExport(date)
      this.downloadFileWithSheet("Consolidado de propina")
    },
    async downloadFile() {
      // Get data to getters
      // const data = this.getExportList
      // Validation if content data
      // if (data.length) {
      //   const sheet = XLSX.utils.json_to_sheet(data)
      //   const book = XLSX.utils.book_new()

      //   XLSX.utils.book_append_sheet(book, sheet, `${file_name}`)
      //   // Personalizar los encabezados
      //   const headings = [ ['Nombre', 'Cédula', 'Sharp Id', 'Propina', 'Banco', 'Tipo de cuenta', 'Número de cuenta'] ]
      //   XLSX.utils.sheet_add_aoa(sheet, headings)
      //   XLSX.writeFile(book, `${file_name} - ${this.date}.xlsx`)

      // } else {
      //   this.message_of_modal = `¡Lo sentimos!, no se encontraron datos para la fecha: ${this.date}`
      //   this.showModal(this.modal_name)
      // }
    },
    downloadFileWithSheet() {
      // Sheet of document
      // const business_line = XLSX.utils.json_to_sheet(this.getExportList.business_line ?? [])
      // const point_of_sale = XLSX.utils.json_to_sheet(this.getExportList.point_of_sale ?? [])
      // const daily = XLSX.utils.json_to_sheet(this.getExportList.daily ?? [])
      // // Constructor of document
      // const excel = XLSX.utils.book_new()
      // // Open and writing data in sheet
      // XLSX.utils.book_append_sheet(excel, business_line, `Linea de negocio - ${this.date}`)
      // XLSX.utils.book_append_sheet(excel, point_of_sale, `Punto de venta - ${this.date}`)
      // XLSX.utils.book_append_sheet(excel, daily, `Diario - ${this.date}`)

      // // Personalizar encabezados
      // const headings_point_of_sale = [ ['Línea de negocio', 'Código punto de venta', 'Punto de venta', 'Propina'] ]
      // XLSX.utils.sheet_add_aoa(point_of_sale, headings_point_of_sale)

      // const headings_daily = [ ['Línea de negocio', 'Código punto de venta', 'Punto de venta', 'Propina', 'Fecha'] ]
      // XLSX.utils.sheet_add_aoa(daily, headings_daily)

      // // Write and download document
      // XLSX.writeFile(excel, `${file_name} - ${this.date}.xlsx`)
    }
  },
};
</script>

<style lang="scss" scoped>
.card-personalizada {
  //width: 772px;
  height: auto;
  left: 112px;
  top: 152px;

  background: #ffffff;

  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.title-row {
  /* Body Semibold */
  //font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #454545;
}

.subtitle-row {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 15px;
  color: #454545;
  opacity: 0.6;

  margin-top: -20px;
}

.text-mute {
  /* Body Semibold */
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */

  display: flex;
  align-items: center;
  text-align: center;

  /* Neutral / Gray 2 */

  color: #aaaaaa;
}
</style>
<style>
.btn_return {
  position: absolute;
  bottom: 16px;
  left: 25%;
  margin: auto;
  align-items: center;
  padding: 6px 12px;
  gap: 4px;
  width: 123px;
  height: 32px;
  /* content/00 */
  background: #ffffff;
  /* CTA/03 */
  border: 1px solid #5d5fef;
  border-radius: 4px;
  top: 50%;
}
</style>